import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useAppContext } from "../../../../context/AppContext";
import { setJourneyIntent } from "../../../../utils/journeyIntent";
import JourneyPage from "./components/JourneyPage";

const ROBOTRADER_APK_URL = "https://robotrader.take-profit-signals.co.za/info/downloads/RoboTrader5.apk";
const ROBOTRADER_VIDEO_URL = "https://www.youtube.com/@ROBOTRADERAPP/playlists";

const getDownloadUrl = (appData) => {
    return appData?.metadata?.mobile_app_url
        || appData?.metadata?.download_url
        || appData?.metadata?.android_app_url
        || ROBOTRADER_APK_URL;
};

const getStudentVideoUrl = (appData) => {
    return appData?.metadata?.student_app_video_url
        || appData?.metadata?.download_help_video_url
        || appData?.metadata?.student_help_video_url
        || ROBOTRADER_VIDEO_URL;
};

export default function StudentWelcome() {
    const { appData, setPageTitle, loggedInUserData } = useAppContext();
    const downloadUrl = getDownloadUrl(appData);
    const studentVideoUrl = getStudentVideoUrl(appData);

    useEffect(() => {
        setPageTitle("Student Start");
        setJourneyIntent({ appId: appData?.id, userData: loggedInUserData, intent: "student" });
    }, [appData?.id, loggedInUserData, setPageTitle]);

    return (
        <JourneyPage
            eyebrow="Student launchpad"
            title={`Use ${appData?.name || "Robotrader"} from your phone`}
            subtitle="Download the mobile app, use the key provided by your mentor, and access Robotrader's mobile robot and AI-powered trading tools from your phone."
            primaryAction={{ to: downloadUrl, label: "Download App" }}
            secondaryAction={{ to: studentVideoUrl, label: "Watch Setup Video" }}
        >
            <div className="row g-3">
                <div className="col-md-6">
                    <div className="journey-card card custom-card h-100">
                        <div className="card-body p-4">
                            <div className="journey-icon journey-icon-success mb-4"><i className="fas fa-mobile-alt"></i></div>
                            <h3 className="journey-card-title h4">Download the mobile app</h3>
                            <p className="journey-card-copy">Install Robotrader 5, open the app, and use the licence key provided by your mentor to connect your mobile robot.</p>
                            <a href={downloadUrl} className="btn btn-success" target="_blank" rel="noreferrer">
                                <i className="fa fa-download me-2"></i>Download App
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="journey-card card custom-card h-100">
                        <div className="card-body p-4">
                            <div className="journey-icon journey-icon-primary mb-4"><i className="fas fa-brain"></i></div>
                            <h3 className="journey-card-title h4">AI trading tools</h3>
                            <p className="journey-card-copy">AI Chart Scanner and AI News Event Predictor are part of the mobile app experience. Download the app to use them.</p>
                            <a href={downloadUrl} className="btn btn-primary" target="_blank" rel="noreferrer">
                                <i className="fa fa-download me-2"></i>Download App
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="journey-card card custom-card h-100">
                        <div className="card-body p-4">
                            <div className="journey-icon journey-icon-warning mb-4"><i className="fas fa-key"></i></div>
                            <h3 className="journey-card-title h4">Use your mentor key</h3>
                            <p className="journey-card-copy">Your mentor provides the key. Enter it inside the mobile app to unlock your robot and connected tools.</p>
                            <a href={downloadUrl} className="btn btn-warning text-white" target="_blank" rel="noreferrer">Download App</a>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="journey-card card custom-card h-100">
                        <div className="card-body p-4">
                            <div className="journey-icon journey-icon-info mb-4"><i className="fas fa-life-ring"></i></div>
                            <h3 className="journey-card-title h4">Watch the guide</h3>
                            <p className="journey-card-copy">Follow the download and setup video to install Robotrader, enter your key, and start using the app.</p>
                            <a href={studentVideoUrl} className="btn btn-info text-white" target={studentVideoUrl.startsWith("/") ? "_self" : "_blank"} rel="noreferrer">Watch Video</a>
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <Link to="/welcome" className="btn btn-light mt-2">Switch Journey</Link>
                </div>
            </div>
        </JourneyPage>
    );
}
